import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../Store';
import SEO from '../../components/seo';

// Layout
import Layout from '../../components/layouts/Layout/index';

// Fields
import Content from '../../components/fields/Content';

import './style.scss';

const NodePageTemplate = ({ data, user, notification, actions }) => {
    const { title } = data.nodePage;
    const { content } = data.nodePage.r;
    const files = data.allFileFile.edges;
    return (
        <Layout user={user} notification={notification} actions={actions}>
            <SEO title={title} />
            <div className="copy-text">
                <div className="upper-content">
                    <h1 className="text-center">{title}</h1>
                </div>
                <div className="lower-content">
                    <div className="inner-area">
                        <Content content={content} files={files} />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

NodePageTemplate.propTypes = {
    data: PropTypes.shape({
        nodePage: PropTypes.shape({
            title: PropTypes.string,
            r: PropTypes.shape({
                content: PropTypes.array,
            }),
        }).isRequired,
        allFileFile: PropTypes.shape({
            edges: PropTypes.array,
        }).isRequired,
    }),
};

export default connect(mapStateToProps, mapDispatchToProps)(NodePageTemplate);

export const query = graphql`
    query pageTemplate($slug: Int) {
        nodePage(drupal_internal__nid: { eq: $slug }) {
            ...nodePageFragment
        }
        allFileFile {
            ...allFileFragment
        }
    }
`;
